/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Form, Select } from 'antd';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import ModalDelete from '../../../../components/Shared/modal/delete';
import useNotify from '../../../../context/Notification/useNotify';
import DataFlowService from '../../../../services/DataFlow.service';
import TableDataBase from '../DataflowDetail/components/TableDataBase';
import { ROUTER } from '../../../../constants/router';
import { STATUS_ID as STATUS } from '../../STATUS_ID';

const { Option } = Select;

export default function Tab7({ databaseInfo, editMode, isNoPermission, dataFlowInfo }) {
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();
    const { businessProcessId } = useParams();
    const [form] = Form.useForm();
    const [departmentList, setDepartmentList] = useState([]);
    const [openDelete, setOpenDelete] = useState(false);
    const [disabledPeriod, setDisabledPeriod] = useState(true);

    const notify = useNotify();

    useEffect(() => {
        getSyncDepartmentList();
    }, []);

    useEffect(() => {
        if (departmentList) {
            form.setFieldsValue({ ...databaseInfo });
        }
    }, [departmentList]);

    const getSyncDepartmentList = async () => {
        try {
            const { data } = await DataFlowService.getSyncDepartmentList(
                businessProcessId
            );
            if (data?.resultData) {
                setDepartmentList(data?.resultData);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const deleteDatabase = async () => {
        await DataFlowService.deleteDatabase(businessProcessId)
            .then((res) => {
                setOpenDelete(false);
                notify({
                    title: t('common.Success'),
                    description: t('dataFlow.SuccessfullyToClearData'),
                });
                changePage();
            })
            .catch((err) => {
                setOpenDelete(false);
                notify({
                    type: 'error',
                    title: t('common.Fail'),
                    description: t('dataFlow.FailedToClearData'),
                });
            });
    };

    const changePage = () => {
        navigate(`${ROUTER.DS_INVENTORY.DATAFLOW}/${businessProcessId}?tab=5`);
    };

    // const onChangeDepartmentId = (e) => {
    //     if (e) {
    //         setDisabledBtnSync(false);
    //     }
    // };

    return (
        <>
            <Form form={form} layout="vertical">
                <div className="grid grid-cols-2">
                    <div className="col-span-1">
                        <div className="grid grid-cols-3">
                            <div className="col-span-2">
                                <Form.Item
                                    className="initial"
                                    name="departmentId"
                                >
                                    <Select
                                        disabled={true}
                                        size="large"
                                        placeholder={t(
                                            'dataFlow.SelectDepartmentSync'
                                        )}
                                        showSearch
                                        optionFilterProp="children"
                                        filterOption={(input, option) =>
                                            (option?.children ?? '')
                                                .toLowerCase()
                                                .includes(input.toLowerCase())
                                        }
                                    >
                                        {departmentList.map((item) => (
                                            <Option
                                                size="large"
                                                key={item.departmentId}
                                                value={item.departmentId}
                                            >
                                                {i18n.language === 'en'
                                                    ? item.departmentNameEn
                                                    : item.departmentNameTh}
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </div>
                            <div className="col-span-1 px-2">
                                <Button
                                    hidden={
                                        !databaseInfo?.database || !editMode
                                    }
                                    size="large"
                                    type="default"
                                    onClick={() => setOpenDelete(true)}
                                    className="text-[#1890FF] border-[#1890FF] hover:text-blue-400 hover:border-blue-400 "
                                >
                                    {t('dataFlow.ClearData')}
                                </Button>
                            </div>
                        </div>
                    </div>
                    <div className="col-span-1 flex justify-end">
                        <Button
                            hidden={!editMode || (isNoPermission && dataFlowInfo.statusId !== STATUS.REVISE) }
                            type="primary"
                            style={{ padding: '0px 30px' }}
                            size="large"
                            ghost
                            onClick={() => changePage()}
                        >
                            {t('common.Edit')}
                        </Button>
                    </div>
                    <TableDataBase
                        databaseInfo={databaseInfo}
                        viewMode={true}
                        form={form}
                        disabledPeriod={disabledPeriod}
                        setDisabledPeriod={setDisabledPeriod}
                    />
                </div>
            </Form>

            <ModalDelete
                open={openDelete}
                text={t('dataFlow.DoYouWantToClearData')}
                title={t('dataFlow.ConfirmClearData')}
                handelOk={() => {
                    deleteDatabase();
                }}
                handelClose={() => setOpenDelete(false)}
            />
        </>
    );
}
